import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  acao: string;
}

export function ModalCertezaAcaoSelecionados({
  show,
  handleClose,
  onConfirm,
  acao,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={`${acao === "bloquear" ? "Bloquear" : "Desbloquear"} veículo`}
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText={acao === "bloquear" ? "Bloquear" : "Desbloquear"}
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja {acao} o(s) veículo(s) selecionado(s)?
      </ModalBody>
    </ModalCustom>
  );
}
